import * as Sentry from '@sentry/browser';


let sentryConfigElement = document.querySelector<HTMLElement>('#sentry-config')!;
let {userEmail, userId, sentryPublicDsn} = sentryConfigElement.dataset;

Sentry.init({
  dsn: sentryPublicDsn,
  release: SENTRY_RELEASE,
  whitelistUrls: [
    /.+\.simcontrol\..+/,
    /.+\.v2nmobile\..+/,
    /.*simmanager\.vodacom\.co\.tz.*/,
    /.*simmanagement\.vm\.co\.mz.*/,
  ],
});

Sentry.configureScope(scope => {
  scope.setUser({
    id: userId,
    email: userEmail,
  });
});
